"use client";

import { useState } from "react";

import PublicFaqAccordion from "@/components/faq/PublicFaqAccordion";
import type { PublicFaqItem } from "@/lib/faq-public";
import { ga4CtaClick } from "@/lib/analytics/ga4-ecommerce";

type Props = {
	items: PublicFaqItem[];
	previewCount?: number;
	className?: string;
	ctaLocation?: string;
};

export default function ExpandablePublicFaqAccordion({
	items,
	previewCount = 10,
	className,
	ctaLocation = "service_faq",
}: Props) {
	const [expanded, setExpanded] = useState(false);
	const hasMore = items.length > previewCount;
	const visibleItems = expanded ? items : items.slice(0, previewCount);

	return (
		<div className={className}>
			<PublicFaqAccordion items={visibleItems} ctaLocation={ctaLocation} />
			{hasMore ? (
				<div className="mt-8 text-center">
					<button
						type="button"
						className="text-sm font-semibold text-secondary underline-offset-4 transition-colors hover:underline"
						onClick={() => {
							const next = !expanded;
							const locationSlug = ctaLocation
								.trim()
								.toLowerCase()
								.replace(/[^a-z0-9]+/g, "_")
								.replace(/^_|_$/g, "");
							ga4CtaClick({
								cta_id: next
									? `faq_see_more_${locationSlug || "faq"}`
									: `faq_see_less_${locationSlug || "faq"}`,
								cta_name: next ? "See more" : "See less",
								cta_location: ctaLocation,
							});
							setExpanded(next);
						}}
						aria-expanded={expanded}
					>
						{expanded ? "See less" : "See more"}
					</button>
				</div>
			) : null}
		</div>
	);
}
